<template>
  <tr class="bg-primary-200 even:bg-primary-50">
    <slot />
  </tr>
</template>
